import React from 'react';
import { useTranslation } from 'react-i18next';
import { hasHelpFile } from './HelpView';
import { Button, ButtonVariant } from '@patternfly/react-core';
import Icons, { Size } from '../Common/Icons';
import HelpModal from './HelpModal';
import useBoolean from '../../utils/hooks/useBoolean';
import PropTypes from 'prop-types';
import styles from './HelpButton.module.css';

const HelpButton = ({ file, className }) => {
  const { i18n } = useTranslation();
  const [isHelpOpen, showHelp, hideHelp] = useBoolean(false);
  const hasFile = hasHelpFile(file, i18n.language);
  return (<>
    <Button className={hasFile ? styles.button : styles.buttonGone} variant={ButtonVariant.plain} onClick={showHelp}>
      <Icons.Help className={className} size={Size.MEDIUM} />
    </Button>
    { hasFile && <HelpModal file={file} onClose={hideHelp} isOpen={isHelpOpen} /> }
  </>);
};

HelpButton.propTypes = {
  file: PropTypes.string,
  className: PropTypes.string
};

export default React.memo(HelpButton);
